// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__Ht7xU","inner":"styles_inner__Px25D","left":"styles_left__LSN4p","links":"styles_links__N8Njg","hr":"styles_hr__fAETc","copy":"styles_copy__riGxX"};